<template>
  <Tabs v-model="activeTabName" :width="160" :height="60">
    <TabPane v-for="item in tabPages" :cnLabel="item.cnText" :enLabel="item.enText" :name="item.name">
      <component :is=item.component></component>
    </TabPane>
  </Tabs>
</template>
<script>
import {TabPane, Tabs} from "@/components/TabPage";
import RoadRescueFund from "@/views/rescue/RoadRescueFund";

export default {
  name: "rescueCom",
  components: {
    Tabs,
    TabPane,
    RoadRescueFund,
  },
  created() {
  },
  data() {
    return {
      // 默认展示Tab
      activeTabName: "RoadRescueFund",
      tabPages: [
        {
          cnText: '路救基金',
          enText: 'Road Rescue Fund',
          name: 'RoadRescueFund',
          component: 'RoadRescueFund',
        }
      ]
    };
  },
};
</script>
<style lang="less">
</style>
